import { SelectOption } from '@tryhackme/thm-ui-components';

export const defaultOption: SelectOption = { id: '1', value: '10', label: '10' };

export const SelectOptions: SelectOption[] = [
  {
    id: '1',
    value: '10',
    label: '10',
  },
  {
    id: '2',
    value: '20',
    label: '20',
  },
  {
    id: '3',
    value: '30',
    label: '30',
  },
  {
    id: '4',
    value: '40',
    label: '40',
  },
];
